const doc = [({"ja":({"adminConstantLanguageType":({"ja":"日本語", "en":"英語", "zhCn":"中国語(簡体字)", "zhTw":"中国語(繁体字)", "ko":"韓国語"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;